import api from "../lib/axiosInstance";
import { Job, JobInput, JobInquiry } from "../lib/types/job";
import { Evaluation } from "../lib/types/evaluation";
import { JobLanguage } from "../lib/enums/jobs.enum";

class JobService {
  public async analayz(data: JobInput): Promise<Job> {
    try {
      const result = await api.post(`/job/analayz`, data);

      return result.data;
    } catch (err) {
      console.log("Error, analayz:", err);
      throw err;
    }
  }

  public async evaluate(
    evaluation: Evaluation,
    answer: string,
    language: JobLanguage
  ): Promise<Evaluation> {
    try {
      const result = await api.post(`/job/evaluate`, {
        _id: evaluation._id,
        jobId: evaluation.jobId,
        question: evaluation.question,
        answer: answer,
        language: language,
      });

      return result.data;
    } catch (err) {
      console.log("Error, evaluate:", err);
      throw err;
    }
  }

  public async getMyJobs(
    inquiry: JobInquiry
  ): Promise<{ data: Job[]; totalCount: number }> {
    try {
      const result = await api.get(
        `/job/my?page=${inquiry.page}&limit=${inquiry.limit}`
      );

      return result.data;
    } catch (err) {
      console.log("Error, getMyJobs:", err);
      throw err;
    }
  }

  public async getJob(jobId: string): Promise<Job> {
    try {
      const result = await api.get(`/job/${jobId}`);

      return result.data;
    } catch (err) {
      console.log("Error, getJob:", err);
      throw err;
    }
  }
}

export default JobService;
